import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const images = [
    require('../../images/about2/1.jpg'),
    require('../../images/about2/2.jpg'),
    require('../../images/about2/3.jpg'),
]

var bnr1 = require('./../../images/background/line.png');

class About4 extends React.Component {
    
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    
    render() {
        const options = {
            loop:true,
            autoplay:true,
            autoplayTimeout:3000,
            margin:30,
            nav:false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            dots: true
        };
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-white inner-page-padding">
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-lg-5 col-md-5 ">
                                    <div className="m-about ">
                                        <OwlCarousel className="owl-carousel about-us-carousel" {...options}>
                                            {images.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="ow-img">
                                                    <NavLink to="/about"><img src={item} alt=""/></NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        
                                        </OwlCarousel>
                                        
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-7">
                                    <div className="m-about-containt text-black p-t80">
                                        <div className="m-about-years bg-moving" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                                            <span className="text-primary large-title">5</span>
                                            <span className="large-title-info">Years of Experience</span>
                                        </div>
                                        <h3 className="font-weight-600">PT. Riksa Jaya Swastika</h3>
                                        <p>
                                            Perusahaan jasa keselamatan dan kesehatan kerja bidang pemeriksaan obyek K3 yang berdiri sejak 14 April 2020.
                                            <br />
                                            Dalam perkembangannya, PT Riksa Jaya Swastika sudah dipercayai oleh banyak perusahaan besar dan kecil di Indonesia baik BUMN, BUMD, maupun perusahaan swasta diberbagai bidang industri seperti konstruksi, pertambangan, manufaktur, pusat perbelanjaan, hotel/apartemen, rumah sakit, dan sebagainya. PT. Riksa Jaya Swastika mengutamakan kualitas dan kepuasan pelanggan. Yang didukung oleh sarana prasarana meliputi sumber daya manusia yang professional sesuai standar baik lokal maupun internasional. Dengan mengedepankan kualitas pekerjaan yang maksimal.
                                            <br />
                                            <br />
                                            Kami percaya bahwa pemeriksaan yang menyeluruh dan terintegrasi adalah fondasi bagi terciptanya lingkungan yang aman, sehat, dan berkelanjutan. Melalui pendekatan terpadu dalam setiap proses riksa, kami tidak hanya memastikan kepatuhan terhadap standar, tetapi juga berkontribusi dalam meningkatkan kualitas hidup masyarakat secara menyeluruh. Dengan menggabungkan teknologi, keahlian profesional, dan komitmen terhadap integritas, kami hadir untuk membangun kepercayaan dan memberikan nilai nyata dalam setiap langkah pemeriksaan yang kami lakukan.</p>
                                        <div className="author-info p-t20">
                                            <NavLink to="/about" className="site-button btn-effect m-b15"><span>Get in touch</span></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About4;